import React from 'react';
import { TabValue } from './ViewerContainer';
import { Tab, Tabs } from '@material-ui/core';
import useStyles from './useStyles';
import { ViewerMode } from './types';
import { clsx } from '@components/Provider';

interface Props {
  mode: ViewerMode;
  tab: TabValue;
  onChangeTab: (e: any, value: TabValue) => void;
}

const ViewerMenuTabs = ({ mode, tab, onChangeTab }: Props) => {
  const classes = useStyles();

  const displayTab = [
    { value: 'ALL', label: '전체' },
    { value: 'REQUEST', label: '견적요청서' },
    { value: 'CHAT', label: '채팅방' }
  ];

  if (mode === 'default') return null;

  return (
    <Tabs
      className={clsx(classes['Viewer-Menu-Tabs-root'])}
      value={tab ? tab : 'ALL'}
      onChange={onChangeTab}
    >
      {displayTab.map((v, index) => (
        <Tab
          key={index}
          {...v}
          classes={{
            wrapper: tab === v.value ? 'selected' : undefined
          }}
        />
      ))}
    </Tabs>
  );
};

export default React.memo(ViewerMenuTabs);
